import * as React from 'react';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../../sessionManagement/SessionManagementService';
import { ToasterService } from '../../../ts/services/ToasterService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedStartersSpace } from './ConnectedStartersSpace';
import { StartersSpaceAngularProps, StartersSpaceOwnProps } from './StartersSpace';

export interface StartersSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
  readonly connectionType?: string;
}

const StartersSpaceAngularHOC = angularProviderHOC<StartersSpaceOwnProps, StartersSpaceAngularProps, StartersSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    serverService: getSessionManagementServiceInstance(),
    toasterService: ToasterService.instance,
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedStartersSpace: React.ComponentType<StartersSpaceOwnProps>
  = StartersSpaceAngularHOC(ConnectedStartersSpace);

const StartersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'starters',
  subspaceName: undefined
};

export const StartersSpaceProvider: React.FunctionComponent<StartersSpaceProviderProps> = (props) => {

  return (
    <ConnectedSpaceInfoProvider spaceInfo={StartersSpaceInfo}>
      <AngularWrappedStartersSpace angularContext={props.angularContext} urls={props.urls} selectedConnectionTypeInternalName={props.connectionType}/>
    </ConnectedSpaceInfoProvider>
  );
};
